import React from "react"
import NavBar from "./NavBar"

const Header = () => {
    return (
        <div className="header">
            <p className="nameHeader">Gene Campbell III</p>
            <NavBar />
        </div>
    )
}

export default Header